import { render, staticRenderFns } from "./CreateReservationForm.vue?vue&type=template&id=19b66321"
import script from "./CreateReservationForm.vue?vue&type=script&lang=ts"
export * from "./CreateReservationForm.vue?vue&type=script&lang=ts"
import style0 from "./CreateReservationForm.vue?vue&type=style&index=0&id=19b66321&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports